import type { AuthSession, AuthUser } from '@pomodingo/api-client';
import { api, platform } from './client';

export type { AuthUser, AuthSession };

export function getSession(): AuthSession | null {
  return platform.tokenStore.getSession();
}

export function getAccessToken(): string | null {
  return platform.tokenStore.getAccessToken();
}

export async function requestMagicLink(email: string): Promise<void> {
  return api.auth.requestMagicLink(email);
}

export async function verifyMagicLink(token: string): Promise<AuthSession> {
  return api.auth.verifyMagicLink(token);
}

export async function refreshSession(): Promise<AuthSession | null> {
  return api.auth.refreshSession();
}

export async function signOut(): Promise<void> {
  await api.auth.signOut();
  localStorage.removeItem('is_premium');
  localStorage.removeItem('user_id');
}
